Librarian.Modules.UserFileList = new Class({
    Extends: Librarian.Modules.Module,
    Binds: ["onNameClicked", "onCountClicked"],

    options: {
        classPrefix: "modules-userfilelist-",
        count: 10,
        countOptions: ["5", "20", "40"],
        catType: Librarian.catType.uploads
    },

    fileList: null,

    initialize: function(options, wrapperEl) {
        this.setOptions(options);

        this.options.title = Librarian.Lang.getString((this.options.catType == Librarian.catType.uploads) ? "uploads" : "proc");

        this.parent(this.options, wrapperEl);
    },

    destroy: function() {
        if (this.fileList) {
            this.fileList.destroy();
            this.fileList = null;
        }
    },

    load: function() {
        if (!this.wrapperEl)
            return;

        this.parent();

        var listEl = new Element("div", {
            "class": (this.options.classPrefix || '') + "list"
            }).injectInside(this.containerEl),
            options = {
                container: listEl,
                showDownload: false,
                showShare: true,
                addSpacer: false,
                onNameClicked: this.onNameClicked
            };

        if (this.options.catType == Librarian.catType.uploads)
            options.catId = Librarian.specialCategories.UserUploads;
        else
            options.catId = Librarian.specialCategories.UserApproved;

        this.fileList = new Librarian.FileList(options);
        this.fileList.load(this.options.count);

        if (this.options.countOptions && (this.options.countOptions.length > 0)) {
            var countContEl = new Element("div", {
                "class": (this.options.classPrefix || '') + "options"
            }).injectInside(this.containerEl);

            for (var i = 0, length = this.options.countOptions.length; i < length; i++) {
                var count = this.options.countOptions[i];
                if (i == 0)
                    count = "Last " + count;

                var countEl = new Element("a", {
                    "class": "listitem bolder",
                    "text": count
                }).injectInside(countContEl);

                countEl.addOnClick(this.onCountClicked);

                new Element("span", {
                    "text": " - "
                }).injectInside(countContEl);
            }

            var allEl = new Element("a", {
                "class": "listitem bolder",
                "text": "Show All"
            }).injectInside(countContEl);
            allEl.addOnClick(this.onCountClicked);
        }
    },

    onCountClicked: function(e) {
        if (!this.fileList)
            return;

        var evt = new Event(e),
            count = (Librarian.Utils.getElementValue($(evt.target)) || '').trim();

        // Pull the number out of the "Last X" option
        if (count.startsWith("Last"))
            count = count.split(' ')[1];

        if (isNaN(count.toInt()))
            count = null;

        this.fileList.load(count);
    },

    onNameClicked: function(data) {
        window.open(Librarian.Utils.getFileDownloadUrl(data.fileid), "_download");
    },

    refresh: function() {
        if (this.fileList) {
            this.fileList.reset(true);
        }
    }
});